import { CleaveInput, ValidatedInput } from '@cp-shared-19/frontend-ui';
import React, { useEffect, useState } from 'react';

const mileageCleaveOptions = {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalScale: 0,
    numeralDecimalMark: ',',
    numeralPositiveOnly: true,
    delimiter: '.',
} as const;

type MileageInputProps = {
    className?: string;
    label: string;
    name: string;
    testId?: string;
    addonText?: string;
    disabled?: boolean;
};

export const MileageInput: React.FC<MileageInputProps> = props => {
    const [isInputMounted, setIsInputMounted] = useState(false);

    useEffect(() => {
        setIsInputMounted(true);
    }, []);

    // CleaveInput initializes only when the input already exists in the DOM.
    return isInputMounted ? (
        <CleaveInput cleaveOptions={mileageCleaveOptions} inputMode={'numeric'} {...props} />
    ) : (
        <ValidatedInput type="text" inputMode={'numeric'} {...props} />
    );
};
